import cx from 'classnames'
import { Button } from 'blaze-ui/Button'
import { Form } from '../Form/Form'
import { Wizard } from '../Wizard/Wizard'
import { StepProps } from './Types'
import Styles from './MultiStepWizard.module.scss'
import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { ConditionalInlineLanguageInputField as InlineLanguageInputField } from '../Wizard/Form/LanguageInputField/ConditionalLanguageInputField'

const ValuesObserver = ({ onChange }: { onChange: (values: any) => any }) => {
  const { values } = useFormikContext()

  useEffect(() => {
    onChange(values)
  }, [values]) // eslint-disable-line
  return null
}

export const Step = ({ schema, initialValues, onBack, onSubmit, onChange }: StepProps) => {
  const {
    meta: { submitLabel = 'Submit' },
    fields,
  } = schema.describe()

  const fieldNames = Object.keys(fields)

  return (
    <Wizard.Form
      schema={schema}
      onSubmit={onSubmit}
      initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
    >
      {onChange && (
        <ValuesObserver
          onChange={(newValues) => {
            onChange(newValues)
          }}
        />
      )}
      <div className={Styles.buttonContainer}>
        {onBack && (
          <Button variant="tertiary" size="lg" onPress={() => onBack()}>
            Previous Step
          </Button>
        )}
        <div className={cx(Styles.buttonContainer, Styles.rightButtons)}>
          {fieldNames.includes('language') && (
            <ResponsiveDesign.Desktop>
              <InlineLanguageInputField />
            </ResponsiveDesign.Desktop>
          )}
          <Form.SubmitButton>{submitLabel}</Form.SubmitButton>
        </div>
      </div>
    </Wizard.Form>
  )
}

export const MultiStep = multiStep(Step)
